export default __webpack_public_path__ + "static/media/80CA8A65-5E9D-48F6-88B9-C84A66E13F65_1_105_c.f035b27f.jpeg";